<template lang="pug">
  div
    .toolbar
      .mobile-title
        span.mobile-title__number.semibold {{parentTitle.number}}
        span {{parentTitle.text}}
      h1.title {{ $translate(title) }}
    .content.max-height-initial.overflow-visible
      .optimal-layout__wrapper
        optimal-layout-location(
          :year-options="yearOptions"
          :parameters-list="parametersList"
          :map-center="mapCenter"
        )
        optimal-layout-params(
          :year-options="yearOptions"
          :parameters-list="parametersList"
          :map-center="mapCenter"
        )
</template>

<script>
import axios from 'axios'

import OptimalLayoutLocation from './optimal-layout-components/optimal-layout-location'
import OptimalLayoutParams from './optimal-layout-components/optimal-layout-params'
import { threads } from '@/api/api-endpoints'
import { REGION_CONFIG } from '@/config/regions'
import parentTitle from '@/mixins/parentTitle'

export default {
  components: { OptimalLayoutParams, OptimalLayoutLocation },
  mixins: [parentTitle],
  data() {
    return {
      parametersList: [],
      mapCenter: REGION_CONFIG.map,
    }
  },
  computed: {
    title() {
      return this.$route.meta.title
    },
    yearOptions() {
      const date = new Date()
      const years = []
      const yearStart = date.getFullYear()
      const yearFinish = yearStart + 10
      for (let i = yearStart; i < yearFinish; i++) {
        years.push({ id: i, name: i })
      }
      return years
    },
  },
  methods: {
    setParametersList(list) {
      this.parametersList = list
    },
    async getMaxParameterList() {
      const url = threads.maxParametersList()
      axios
        .get(url)
        .then((response) => this.setParametersList(response.data))
        .catch(() =>
          this.$e.errorBox('Ошибка загрузки параметров! Обновите страницу')
        )
    },
  },
  mounted() {
    this.getMaxParameterList()
  },
}
</script>
